import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from "src/app/models/utilities";
import { EmailValidation, MobileNumberValidation, TelephoneNumberValidation } from "src/app/models/validator";
import { AppCoreService } from "src/app/services/app-core.service";
import { VendorService } from "src/app/services/vendor.service";
import Swal from "sweetalert2";


@Component({
  selector: 'app-editvendor',
  templateUrl: './editvendor.component.html',
  styleUrls: ['./editvendor.component.scss']
})
export class EditVendorComponent implements AfterViewInit {
  vendorId: string;
  vendorForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted: boolean;
  vendorTypeList: any[] = [];
  locationDetails: any;
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private appCoreService: AppCoreService,
    private vendorService: VendorService,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private utilities: Utilities,
  ) {
    titleService.setTitle('Vendors');
  }

  ngOnInit(): void {
    this.vendorTypeList = ['Delivery', 'OBC', 'Vendor'];
    this.vendorForm = this.formBuilder.group({
      ddlVendorMode: ['Delivery', Validators.compose([Validators.required])],
      txtCode: new FormControl({ value: null, disabled: true }),
      txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      txtContactPerson: [null, Validators.compose([Validators.maxLength(50)])],
      txtEmailId: [null, EmailValidation],
      // txtFax: [null, Validators.maxLength(20)],
      fuelApplicable: [false],
      taxApplicable: [false],
      isActive: [false],
      locationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.required],
        ddlState: [null, Validators.required],
        ddlCity: [null, Validators.required],
        txtArea: [null, Validators.maxLength(30)],
        txtPincode: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
      apiEnabled: [false]
    });

    this.isFormSubmitted = false;
    this.vendorId = this.route.snapshot.params['id'];

    this.checkPermission();
    if (this.permConfig.isEditAllowed) {
      this.bindVendorDetailsById();
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.vendorForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Vendors');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindVendorDetailsById() {
    this.vendorService.GetById(this.vendorId).subscribe((res) => {
      if (res && res.success) {
        // console.log(res);
        this.vendorForm.patchValue({
          ddlVendorMode: res.data[0]?.vendormode,
          txtCode: res.data[0]?.code,
          txtName: res.data[0]?.name,
          txtContactPerson: res.data[0]?.contactperson,
          txtEmailId: res.data[0]?.emailid,
          // txtFax: res.data[0]?.fax,
          fuelApplicable: res.data[0]?.fuelapplicable,
          taxApplicable: res.data[0]?.taxapplicable,
          isActive: res.data[0]?.isactive,
          apiEnabled: res.data[0]?.apienabled,

        });
        // bind location details for child component
        this.locationDetails = res.data[0]?.location;
      }
    })
  }

  updateVendor() {
    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('No access to Edit.');
      return;
    }
    this.isFormSubmitted = true;
    if (this.permConfig.isEditAllowed && this.vendorForm.valid) {
      let vendorArea = this.vendorForm.get('locationdetails').get('txtArea')?.value;
      vendorArea = vendorArea && typeof vendorArea === 'string' ? vendorArea : vendorArea?.area;

      let vendorPincode = this.vendorForm.get('locationdetails').get('txtPincode')?.value;
      vendorPincode = vendorPincode && typeof vendorPincode === 'string' ? vendorPincode : vendorPincode?.pincode;
      const requestObj = {
        id: this.vendorId,
        name: this.vendorForm.get('txtName').value,
        contactperson: this.vendorForm.get('txtContactPerson').value,
        emailid: this.vendorForm.get('txtEmailId').value,
        // fax: this.vendorForm.get('txtFax').value,
        fuelapplicable: this.vendorForm.get('fuelApplicable').value,
        taxapplicable: this.vendorForm.get('taxApplicable').value,
        isactive: this.vendorForm.get('isActive').value,
        apienabled: this.vendorForm.get('apiEnabled').value,
        vendormode: this.vendorForm.get('ddlVendorMode').value,
        location: {
          country: this.vendorForm.get('locationdetails').get('ddlCountry').value,
          state: this.vendorForm.get('locationdetails').get('ddlState').value,
          city: this.vendorForm.get('locationdetails').get('ddlCity').value,
          area: vendorArea,
          pincode: vendorPincode,
          address1: this.vendorForm.get('locationdetails').get('txtAddress1').value,
          address2: this.vendorForm.get('locationdetails').get('txtAddress2').value,
          mobileno: this.vendorForm.get('locationdetails').get('txtMobileNo').value,
          tel: this.vendorForm.get('locationdetails').get('txtTelephoneNo').value
        },

      }
      this.ngxLoaderService.start();
      this.vendorService.Update(requestObj).subscribe((res) => {
        try {
          if (res && res?.success) {
            this.ngxLoaderService.stop();
            this.openSuccessDialog("Record Updated successfully");
          } else if (res && !res?.success) {
            this.ngxLoaderService.stop();
          }
        }
        catch (err) {
          this.ngxLoaderService.stop();
          console.error(err);
        }
      });

    }
  }

  resetForm(): void {
    this.vendorForm.reset();
    this.isFormSubmitted = false;
  }

  async openSuccessDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/setup/vendors']);
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}
